/**
 * Library-document bindings in a piece's editorial direction.
 *
 * Pure and React-free on purpose, like pipeline-status.ts: the Create Piece
 * modal cannot be imported from a test because it reaches for
 * `import.meta.env`, and this rule needs testing more than the modal does.
 */

/**
 * Does this editorial direction bind any library documents?
 *
 * S-382 gates "Only these sources" on it. Skipping the research phases with
 * nothing bound would not scope the piece, it would starve it: the Writer
 * would run with no reference cards and no library block and produce an
 * unsourced draft that looks like every other draft. The trailing character
 * class is what makes `library docs:` with an empty list read as no binding.
 */
export function hasLibraryRefs(direction: string): boolean {
  return /library docs?:\s*[a-z0-9-]/i.test(direction);
}
